// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"1ab4538c","887":"256f68b1"}[chunkId] + ".chunk.css";
};